/**
 * Field length limits — kept in sync with the API (`BIN_FIELD_LIMITS`) and the
 * old AIMS bin dialog validation.
 */
export const BIN_FIELD_LIMITS = {
  ailse: 20,
  rack: 3,
  shelf: 3,
  bin: 3,
} as const;

const clean = (value?: string | null): string => (value ?? '').trim();

/**
 * Builds the bin location name from its parts, hierarchically — the same rule
 * the API applies on save, so the field shown here always matches what gets
 * stored. The chain stops at the first blank segment.
 *
 *   A12          → aisle only
 *   A12-3        → aisle + rack
 *   A12-3-2      → aisle + rack + shelf
 *   A12-3-2-4    → all four
 */
export const buildBinLocationName = (parts: {
  ailse?: string | null;
  rack?: string | null;
  shelf?: string | null;
  bin?: string | null;
}): string => {
  const ailse = clean(parts.ailse);
  if (!ailse) return '';

  const rack = clean(parts.rack);
  if (!rack) return ailse;

  const shelf = clean(parts.shelf);
  if (!shelf) return `${ailse}-${rack}`;

  const bin = clean(parts.bin);
  if (!bin) return `${ailse}-${rack}-${shelf}`;

  return `${ailse}-${rack}-${shelf}-${bin}`;
};
